import { useTranslation } from 'react-i18next';

import {
    IconCategoryActivities,
    IconCategoryAnimals,
    IconCategoryFood,
    IconCategoryObjects,
    IconCategorySmileys,
    IconCategorySymbols,
    IconCategoryTravel,
} from '@pkg/assets/icons';
import { EmojiCategory } from '@pkg/hooks';
import { type SvgIconComponent } from '@pkg/types';

export interface ContentData {
    title: string;
    ariaLabel: string;
    icon: SvgIconComponent;
}

// TODO: Would be convienent to type this as:
// export type CategoryContent = { [key in EmojiCategory]: ContentData; };
// But we do not support all keys in `EmojiCategory`, as we
// do not want our returned data to think anything is `undefined`.

export type CategoryContentReturn = ReturnType<typeof useCategoryContent>;

export function useCategoryContent() {
    const { t: translate } = useTranslation('emoji');

    return {
        [EmojiCategory.Smileys]: {
            title: translate('category_smileys'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_smileys') }),
            icon: IconCategorySmileys,
        },
        [EmojiCategory.Animals]: {
            title: translate('category_animals'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_animals') }),
            icon: IconCategoryAnimals,
        },
        [EmojiCategory.Food]: {
            title: translate('category_food'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_food') }),
            icon: IconCategoryFood,
        },
        [EmojiCategory.Activities]: {
            title: translate('category_activities'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_activities') }),
            icon: IconCategoryActivities,
        },
        [EmojiCategory.Travel]: {
            title: translate('category_travel'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_travel') }),
            icon: IconCategoryTravel,
        },
        [EmojiCategory.Objects]: {
            title: translate('category_objects'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_objects') }),
            icon: IconCategoryObjects,
        },
        [EmojiCategory.Symbols]: {
            title: translate('category_symbols'),
            ariaLabel: translate('navItemAriaLabel', { category: translate('category_symbols') }),
            icon: IconCategorySymbols,
        },
    };
}

///
/// Notes

/*
At the moment, we do not support the `Flags` or `Component` emojis
within the `EmojiPicker`. We may want to support this in the future.
If so, then we need to implement a feature for the `EmojiPicker` to
optionally specify which emoji categories (and possibly even which
individual emojis) should be included in the results.

[EmojiCategory.Flags]: {
    title: translate('category_flags'),
    ariaLabel: translate('navItemAriaLabel', { category: translate('category_flags') }),
    icon: IconAsset
},
[EmojiCategory.Component]: {
    title: translate('category_component'),
    ariaLabel: translate('navItemAriaLabel', { category: translate('category_component') }),
    icon: IconAsset
},
*/
